import React, { useState, useEffect } from 'react';
import { Col, Row } from '../../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../../components/fields/Abstract/FieldDTOWithCol';
import Switches from '../../../../../components/fields/Switches/Switches';
import TextInputWithLabel from '../../../../../components/fields/TextInput/TextInputWithLabel';
import DateTimePicker from '../../../../../components/fields/DatePicker/DateTimePicker';
import CarrierDTO from '../../../../../dto/CarrierDTO';
import FileInput from '../../../../../components/fields/FileInput/FileInput';
import { PROCEDURE_TYPE, USER_TYPE } from '../../../../../configs';

export default function DriverLicenseForm(props) {
  const {
    control,
    formMeta,
    applicantType,
    procedure,
    isEdit = false,
    currentApplication = {},
    setValue,
    getValues,
  } = props;

  const dto = new CarrierDTO({ legal_entity_type: applicantType, optional: true });
  const attributes = dto.getAttributesByName();

  const [showDriverLicense, setShowDriverLicense] = useState(
    isEdit ? !!(
      currentApplication?.application_carrier_new?.driver_license_series
                || currentApplication?.application_carrier_new?.driver_license_number
                || currentApplication?.application_carrier_new?.driver_license_issue_date
                || currentApplication?.application_carrier_new?.driver_license_expiration_date
    ) || currentApplication?.application_carrier_new?.driver_license_series === null
            || currentApplication?.application_carrier_new?.driver_license_number === null
            || currentApplication?.application_carrier_new?.driver_license_issue_date === null
            || currentApplication?.application_carrier_new?.driver_license_expiration_date === null : false,
  );

  useEffect(() => {
    setValue('application_carrier_new.driver_license_series', !showDriverLicense ? null : (isEdit ? getValues('application_carrier_new.driver_license_series') || '' : ''));
    setValue('application_carrier_new.driver_license_number', !showDriverLicense ? null : (isEdit ? getValues('application_carrier_new.driver_license_number') || '' : ''));
    setValue('application_carrier_new.driver_license_issue_date', !showDriverLicense ? null : (isEdit ? getValues('application_carrier_new.driver_license_issue_date') || '' : ''));
    setValue('application_carrier_new.driver_license_expiration_date', !showDriverLicense ? null : (isEdit ? getValues('application_carrier_new.driver_license_expiration_date') || '' : ''));
    if (!showDriverLicense) setValue('media.driver_license_files', null);
  }, [showDriverLicense]);

  if (![PROCEDURE_TYPE.PROCEDURE_1227_5].includes(procedure) || applicantType !== USER_TYPE.PRIVATE_PERSON) {
    return null;
  }

  return (
    <>
      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => setShowDriverLicense(!showDriverLicense),
              value: showDriverLicense,
            }}
            label="Изменилось водительское удостоверение"
          />
        </Col>
      </Row>
      {showDriverLicense && (
        <>
          <Row className="row-cols-3">
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={TextInputWithLabel}
              dtoObject={attributes.driver_license_series}
              variant="material"
              namePrefix="application_carrier_new."
              labelPrefix="new."
            />
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={TextInputWithLabel}
              dtoObject={attributes.driver_license_number}
              variant="material"
              namePrefix="application_carrier_new."
              labelPrefix="new."
            />
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={DateTimePicker}
              hideTime
              changeFormat="YYYY-MM-DD"
              dtoObject={attributes.driver_license_issue_date}
              variant="material"
              withLabel
              namePrefix="application_carrier_new."
              labelPrefix="new."
            />
          </Row>
          <Row className="row-cols-2">
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={DateTimePicker}
              hideTime
              changeFormat="YYYY-MM-DD"
              dtoObject={attributes.driver_license_expiration_date}
              variant="material"
              withLabel
              namePrefix="application_carrier_new."
              labelPrefix="new."
            />
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={FileInput}
              dtoObject={attributes.driver_license_files}
              variant="material"
              namePrefix="media."
              multiple
            />
          </Row>
        </>
      )}
      <div className="hr-row mt-3" />
    </>
  );
}
